import { abbrNum } from '@src/shared/includes/functions';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { isNull } from 'lodash';
import React from 'react';

/**
 * TotalRecords
 *
 * @TODO Needs description.
 *
 * @param riskRecordCount
 * @returns {Element}
 * @constructor
 */
export function TotalRecords({ riskRecordCount = 0 }) {
  let count = isNull(riskRecordCount) ? 0 : riskRecordCount;

  if (riskRecordCount > 0) {
    count = abbrNum(riskRecordCount);
  }

  return (
    <ErrorHandler location="src/features/Risk/components/tables/RiskRecords/components/Header/components/TotalRecords/TotalRecords.jsx">
      <Layout.Group>
        <div>
          <Text fontWeight="bold">Total Records:</Text>
        </div>
        <Tooltip content={`Total: ${Number(riskRecordCount).toLocaleString('en-US')}`}>
          <div>
            <Badge css={{ fontWeight: 'bold' }} outline variant="info">
              {count}
            </Badge>
          </div>
        </Tooltip>
      </Layout.Group>
    </ErrorHandler>
  );
}
